module.exports = __webpack_public_path__ + "media/src/website/images/locations/altoetting/altoetting_02-a940197d3564c46581f444d0d5c3f662.jpg";